import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { bsc } from '@reown/appkit/networks'

export const projectId = "cdeb5328c30dfd4e0c2a1058a4caa39c"

if (!projectId) {
  throw new Error('Project ID is not defined')
}
const networks = [bsc]
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: true
})

export const config = wagmiAdapter.wagmiConfig
